// errors.data.ts
//
// Barrel. The catalogue is authored one entry per code across the per-domain
// files, and reassembled here into the two flat maps useErrorStore consumes —
// so a code's message can no longer drift away from its metadata.

import { ErrorEntry, ErrorMetadata } from './error-metadata.types';
import { sharedErrors } from './shared-errors.data';
import { nhsLoginErrors } from './nhs-login-errors.data';
import { verificationCodeErrors } from './verification-code-errors.data';
import { formAvailabilityErrors } from './form-availability-errors.data';
import { prescriptionsErrors } from './prescriptions-errors.data';
import { commsErrors } from './comms-errors.data';
import { appointmentsErrors } from './appointments-errors.data';
import { questionnaireErrors } from './questionnaire-errors.data';

export type { ErrorComponent, ErrorEntry, ErrorMetadata } from './error-metadata.types';

const catalogue: Record<string, ErrorEntry> = {
  ...sharedErrors,
  ...nhsLoginErrors,
  ...verificationCodeErrors,
  ...formAvailabilityErrors,
  ...prescriptionsErrors,
  ...commsErrors,
  ...appointmentsErrors,
  ...questionnaireErrors,
};

export const errorMessages: Record<string, string> = Object.fromEntries(
  Object.entries(catalogue)
    .filter(([, entry]) => entry.message !== undefined)
    .map(([code, entry]) => [code, entry.message as string]),
);

// Only codes that actually carry metadata appear here — resolveMeta falls back to
// `unknown-error` for the rest, which is the behaviour the store already relies on.
export const errorMessageMeta: Partial<Record<string, ErrorMetadata>> = Object.fromEntries(
  Object.entries(catalogue)
    .map(([code, entry]): [string, ErrorMetadata] => {
      const { message: _message, ...meta } = entry;
      return [code, meta];
    })
    .filter(([, meta]) => Object.keys(meta).length > 0),
);
